"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolvedImages = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const react_useimage_1 = __importDefault(require("@opsbase/react-useimage"));
const difference_1 = __importDefault(require("lodash/difference"));
const react_1 = require("react");
function _resolveFileNames(arr) {
    if (arr[0].fileName)
        return arr.map(z => z.fileName);
    return arr;
}
function _hasSameFileNames(first, second) {
    if ((first === null || first === void 0 ? void 0 : first.length) === (second === null || second === void 0 ? void 0 : second.length) && first.length !== 0) {
        const firstNames = _resolveFileNames(first);
        const secondNames = _resolveFileNames(second);
        // there will be difference because we are already checking that the lengths are same
        // so if the arrays are different, then at least one element will be different
        return (0, difference_1.default)(firstNames, secondNames).length === 0;
    }
    return false;
}
function useResolvedImages(filenameStrs, alreadyResolvedImages, useFull = false) {
    const { getThumbnailImageUrl, getFullImageUrlById } = (0, react_useimage_1.default)();
    const [resolvedImages, setResolvedImages] = (0, react_1.useState)();
    const fileNames = (0, react_1.useMemo)(() => {
        if (!filenameStrs)
            return;
        if (Array.isArray(filenameStrs))
            return filenameStrs;
        return filenameStrs.split(',');
    }, [filenameStrs]);
    const addThumbnailUrl = (0, react_1.useMemo)(() => (attribImage) => __awaiter(this, void 0, void 0, function* () {
        const id = getIdFromPhoto(attribImage.fileName);
        if (attribImage.thumbnailUrl)
            return attribImage;
        const thumbnailUrl = useFull
            ? yield getFullImageUrlById(id)
            : yield getThumbnailImageUrl(id);
        return Object.assign(Object.assign({}, attribImage), { thumbnailUrl });
    }), [getFullImageUrlById, getThumbnailImageUrl, useFull]);
    (0, react_1.useEffect)(() => {
        console.log('here', alreadyResolvedImages === null || alreadyResolvedImages === void 0 ? void 0 : alreadyResolvedImages.length);
        if ((alreadyResolvedImages === null || alreadyResolvedImages === void 0 ? void 0 : alreadyResolvedImages.length) &&
            (!resolvedImages || resolvedImages.length !== alreadyResolvedImages.length)) {
            Promise.all(alreadyResolvedImages.filter(v => !!v).map(addThumbnailUrl))
                .then(z => setResolvedImages(z))
                .catch(doNothing_1.default);
        }
        else if ((fileNames === null || fileNames === void 0 ? void 0 : fileNames.length) &&
            (!resolvedImages || !_hasSameFileNames(resolvedImages, fileNames))) {
            Promise.all(fileNames.filter(v => !!v).map(url => addThumbnailUrl({ fileName: url })))
                .then(z => setResolvedImages(z))
                .catch(doNothing_1.default);
        }
        else if (!!alreadyResolvedImages && !alreadyResolvedImages.length) {
            setResolvedImages(alreadyResolvedImages);
        }
    }, [
        alreadyResolvedImages,
        useFull,
        resolvedImages,
        getFullImageUrlById,
        getThumbnailImageUrl,
        fileNames,
        addThumbnailUrl,
    ]);
    return resolvedImages;
}
exports.useResolvedImages = useResolvedImages;
exports.default = useResolvedImages;
function getIdFromPhoto(url) {
    const values = url.split('?');
    const fileNames = values[0].split('/');
    //return last element
    return fileNames[fileNames.length - 1];
}
